module.exports = __webpack_public_path__ + "static/media/back-arrow-dark.074ca1bd.svg";


//////////////////
// WEBPACK FOOTER
// ./public/assets/images/back-arrow-dark.svg
// module id = 123
// module chunks = 0